import React from 'react';
import * as Sentry from '@sentry/browser';
import { Button } from '@landtrustinc/design-system';
import config from '../../config';
import logo from '../../assets/logo.svg';
import css from './ErrorBoundary.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to Sentry if configured
    if (config.sentryDsn) {
      // Extract only the component stack to avoid circular references
      const safeErrorInfo = errorInfo?.componentStack
        ? { componentStack: errorInfo.componentStack }
        : {};

      Sentry.captureException(error, {
        tags: {
          type: 'react_error_boundary',
        },
        extra: safeErrorInfo,
      });
    }

    // Log to console as fallback
    // eslint-disable-next-line no-console
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className={css.errorContainer}>
          <div className={css.logoSection}>
            <img src={logo} alt="LandTrust" className={css.logo} />
          </div>

          <div className={css.contentSection}>
            <div className={css.title}>Something went wrong</div>
            <div className={css.message}>
              We&apos;re sorry for the inconvenience. Our team has been notified and we&apos;re
              working to fix this issue.
            </div>
          </div>

          <div className={css.buttonSection}>
            <Button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.reload();
              }}
            >
              Reload Page
            </Button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
